import React from 'react'

function CommunityAgreementFR() {
  return (
    <>
      <p className="heading-1">
        Contrat de cession de droits sur le Contenu créé par le Creator
      </p>

      <div className="paragraph-2">
        <p>
          Skeepers est une société par actions simplifiée au capital de 11 480
          257euros, immatriculée au registre du commerce et des sociétés de
          Marseille sous le numéro 879 038 990, dont le siège social est situé
          au 18-20 Avenue Robert Schuman, CS 40494, 13002 Marseille.
        </p>
        <p>
          Dans le présent contrat, le terme « Skeepers » désigne Skeepers et ses
          filiales. Tous les termes commençant par une majuscule sont définis
          dans les Conditions Générales d’Utilisation (CGU) Skeepers Influence.
        </p>
        <p>
          En créant un Contenu, vous reconnaissez et acceptez expressément céder
          à Skeepers, dans les conditions ci-après définies, l’intégralité des
          droits que vous détenez sur le Contenu que vous avez créé
          (conformément aux CGU Skeepers Influence, le terme « Contenu » désigne
          les textes, images, photographies, dessins, avatars, et plus
          généralement toute publication visuelle, textuelle, sonore ou
          graphique du Creator, représentant les Produits, diffusés dans le
          cadre des services), et autorisez expressément Skeepers à utiliser
          votre image dans les conditions précisées ci-après :
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          1. Cession des droits sur le Contenu
        </p>
        <p>
          En contrepartie de la propriété du Produit reçu, vous cédez
          expressément et à titre exclusif à Skeepers l’intégralité des droits
          que vous détenez sur le Contenu, en ce compris le droit pour Skeepers
          :
        </p>
        <ul className="paragraph-2">
          <li>
            d’utiliser, de reproduire, de sous-licencier, de céder, de
            distribuer, de fixer temporairement ou non, de diffuser, de mettre
            en circulation, d’extraire, de télécharger, de stocker, de
            répertorier, de classer dans une base de données, de communiquer au
            public, de représenter, d’exploiter le Contenu sur tous formats et
            sur tous supports connus ou inconnus à ce jour et notamment sans que
            cette liste revête de caractère limitatif, sur internet et ce quels
            que soient le suffixe générique, géographique ou l’extension du nom
            de domaine du site internet concerné et le pays de réception du
            Contenu (en particulier sur la plateforme et le site de Skeepers,
            sur ses réseaux sociaux tels que Facebook, Twitter, Instagram, IGTV,
            Snapchat, sur les sites de partage d’enregistrements audiovisuels
            tels que YouTube, Dailymotion, Pinterest, mais aussi, Weibo, WeChat,
            et, d’une manière générale, sur tout autre support existant ou à
            venir), par toute forme de diffusion comme le cinéma, la télévision
            hertzienne, par satellite, par câblo- opérateur, par la TNT et par
            tout procédé existant ou à venir, en France et à l’étranger ;
          </li>
          <li>
            d’apporter au Contenu toute modification, totale ou partielle, de
            type adjonction, suppression, adaptation, traduction, déclinaison,
            montage et doublage dans une langue autre que la langue française, à
            procéder à toute extraction de tout ou partie du Contenu pour le
            monde entier et sur tout mode d’exploitation approprié et sur tout
            support. Les Contenus cédés pourront également faire l’objet d’une
            adaptation et/ou d’une traduction destinée à permettre leur
            intégration dans le cadre d’une autre œuvre audiovisuelle,
            multimédia et/ou numérique et sur tous les supports définis
            ci-dessus ;
          </li>
          <li>
            de concéder tout ou partie des droits que vous lui cédez aux termes
            du présent contrat. En particulier, pourra être concédé le droit de
            représenter et diffuser votre Contenu, par le biais d’une
            sous-licence, sur tous supports et sous tous formats et notamment :
            <ul className="paragraph-2">
              <li>
                sur internet (en particulier sur tous sites internet et/ou
                réseaux sociaux, tels que Facebook, Twitter, Instagram, IGTV,
                Snapchat, sur les sites de partage d’enregistrements
                audiovisuels tels que YouTube Dailymotion, Pinterest, mais
                aussi, Weibo, WeChat, et, d’une manière générale, sur tout autre
                support existant ou à venir), par toute forme de diffusion comme
                le cinéma, la télévision hertzienne, par satellite, par
                câblo-opérateur, par la TNT et par tout procédé existant ou à
                venir, en France et à l’étranger) et ce quels que soient le
                suffixe générique, géographique ou l’extension du nom de domaine
                du site internet concerné, et le pays de réception du Contenu ;
              </li>
              <li>
                sur tous lieux physiques de vente (magasins, corners), sur les
                foires, salons, lieux physiques de publicité, expositions et
                toutes autres manifestations publiques où le Produit sera vendu
                ou commercialisé ;
              </li>
              <li>
                en interne au profit des membres et salariés du Client ou
                d’autres tiers.
              </li>
            </ul>
          </li>
        </ul>
        <p>
          Cette cession permet à Skeepers d’exploiter lesdits Contenus tant à
          des fins de communication externe qu’interne, qu’à titre gratuit,
          promotionnel, publicitaire, évènementiel, commercial et lucratif
          notamment par la commercialisation et/ou la mise à disposition à ses
          Clients, directement ou par l’intermédiaire de tiers autorisés par
          Skeepers, de produits ou services.
        </p>
        <p>
          La présente cession de droits est consentie à compter du jour de votre
          acceptation du présent contrat et pour la durée légale de protection
          des droits. La présente cession est consentie pour le monde entier.
        </p>
        <p>
          En ce qui concerne vos droits moraux, le droit d'adapter les Contenus
          permettra à la société Skeepers d'apporter des modifications aux
          Contenus, telle que toute modification rendue nécessaire en raison des
          contraintes techniques ou pour permettre l’implémentation des Contenus
          sous quelque forme et sur quelque support choisi par la société
          Skeepers sur lequel les Contenus seront reproduits ou représentés.
          Vous vous interdisez de vous opposer ou de contester ces changements
          mais également de réclamer une compensation ou une rémunération
          quelconque pour ces changements dans la mesure où l'intégrité de votre
          travail est respectée.
        </p>
        <p>
          Vous déclarez et garantissez Skeepers que vous êtes titulaire exclusif
          de l’ensemble des droits cédés sur le Contenu aux termes du présent
          contrat. Vous garantissez en conséquence avoir obtenu de la part des
          éventuels auteurs et/ou assistants étant intervenus dans le cadre de
          la réalisation des Contenus et pouvant bénéficier de droits
          quelconques à faire valoir sur les Contenus, tous les droits et
          autorisations nécessaires vous permettant de céder les droits de
          propriété attachés aux Contenus au profit de Skeepers, et notamment
          les droits d’utiliser la musique attachée à votre Contenu le cas
          échéant.
        </p>
        <p>
          Vous déclarez également que les droits n’ont fait l’objet d’aucun
          transfert partiel ou total, à titre gracieux ou onéreux, d’aucune
          licence d’exploitation de quelque nature que ce soit, d’aucun
          nantissement, ni d’aucun droit de gage, à quiconque, ni d’aucune
          contestation sous quelque forme que ce soit, à l’exception de la
          licence octroyée au réseau social sur lequel vous avez posté le
          Contenu.
        </p>
        <p>
          Vous garantissez la jouissance paisible de ces droits et vous vous
          engagez à indemniser Skeepers de toutes conséquences, notamment
          financières, qui pourraient résulter de toute contestation,
          réclamation ou action engagée par un tiers relativement à la
          titularité des droits sur le Contenu.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">2. Droit à l’image</p>
        <p>
          Dans la mesure où vous apparaissez dans le Contenu, vous autorisez
          expressément Skeepers à utiliser les attributs de votre personnalité
          (notamment image, marque personnelle, logo personnel, nom, prénom et
          voix) afin de permettre à Skeepers d’exercer les droits qui lui sont
          consentis sur le Contenu conformément au point 1 ci-dessus.
        </p>
        <p>
          En contrepartie de la propriété du Produit reçu, vous autorisez
          expressément Skeepers :
        </p>
        <ul className="paragraph-2">
          <li>
            à capter, fixer, reproduire, adapter et diffuser votre image
            (incluant notamment votre image, marque personnelle, logo personnel,
            voix, nom et prénom) sur l’ensemble des supports de fixation, de
            reproduction et de diffusion évoqués au point 1) ci-dessus, et en
            particulier sur internet, sur la plateforme et le site de Skeepers,
            sur ses réseaux sociaux tels que Facebook, Twitter, Instagram, IGTV,
            Snapchat, sur les sites de partage d’enregistrements audiovisuels
            tels que YouTube Dailymotion, Pinterest, mais aussi, Weibo, WeChat,
            et, d’une manière générale, sur tout autre support existant ou à
            venir), par toute forme de diffusion comme le cinéma, la télévision
            hertzienne, par satellite, par câblo-opérateur, par la TNT et par
            tout procédé existant ou à venir, en France et à l’étranger, ce
            quels que soient le suffixe générique, géographique ou l’extension
            du nom de domaine du site internet concerné et le pays de réception
            de le Contenu ;
          </li>
          <li>
            à concéder à ses bénéficiaires (notamment les fabricants,
            distributeurs, sites internet marchands, et plus généralement ses
            clients professionnels etc.) le droit sous licenciable d’utiliser
            les attributs de votre personnalité (notamment image, marque
            personnelle, logo personnel, nom, prénom et voix) sur internet (en
            particulier sur le site internet et/ou les réseaux sociaux, tels que
            Facebook, Twitter, Instagram, IGTV, Snapchat, sur les sites de
            partage d’enregistrements audiovisuels tels que YouTube,
            Dailymotion, Pinterest, mais aussi, Weibo, WeChat, et, d’une manière
            générale, sur tout autre support existant ou à venir), par toute
            forme de diffusion comme le cinéma, la télévision hertzienne, par
            satellite, par câblo- opérateur, par la TNT et par tout procédé
            existant ou à venir, en France et à l’étranger, sur le(s) site(s)
            e-commerce, et ce quels que soient le suffixe générique,
            géographique ou l’extension du nom de domaine du site internet
            concerné, et le pays de réception de le Contenu, sur les lieux
            physiques de vente (magasins, corners), sur les foires, salons,
            expositions, lieux physiques de publicité et toutes autres
            manifestations publiques où le Produit sera vendu ou commercialisé,
            et en interne au profit des membres et salariés du Client ou
            d’autres tiers.
          </li>
        </ul>
        <p>
          La présente autorisation est consentie pour le monde entier et pour
          une durée de vingt (20) ans à compter de la date de votre acceptation
          du présent contrat.
        </p>
        <p>
          Vous déclarez et garantissez avoir obtenu l’accord écrit des personnes
          représentées sur le Contenu, ou de leurs représentants légaux, pour
          l’utilisation des attributs de leur personnalité (notamment image,
          nom, voix) afin que le Contenu puisse être librement utilisé, diffusé,
          reproduit et exploité dans les conditions stipulées aux présentes.
          Vous vous engagez à justifier de cette autorisation, sans délai, sur
          première demande de Skeepers. Vous vous engagez à indemniser Skeepers
          de toutes conséquences qui pourraient résulter de toute contestation,
          réclamation ou action engagée par un tiers relativement à
          l’utilisation des attributs de sa personnalité.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">3. Dispositions communes</p>
        <p>
          La cession de vos droits sur le Contenu conformément au point 1) et
          l’autorisation d’utilisation de votre image accordée conformément au
          point 2) est consentie en vue de l’exploitation, du fonctionnement et
          de la promotion institutionnelle et publicitaire par Skeepers de son
          site, sa plateforme et ses activités ainsi que de la promotion
          institutionnelle et publicitaire des produits, services et activités
          de ses partenaires (notamment les fabricants, distributeurs, sites
          internet marchands, et plus généralement ses clients professionnels
          etc.).
        </p>
        <p>
          Conformément à l’article L.122-7 du Code de la propriété
          intellectuelle, vous reconnaissez et acceptez expressément que la
          présente cession de droits et autorisation d’utilisation de votre
          image est consentie uniquement en contrepartie du produit reçu. Vous
          renoncez à réclamer toute autre forme de contrepartie, y compris
          financière.
        </p>
        <p>
          Dans l’hypothèse où au moment de l’acceptation du présent contrat,
          vous êtes mineur (moins de 18 ans), vous déclarez et garantissez
          Skeepers avoir obtenu l’autorisation de vos parents ou du(es)
          titulaire(s) de l’autorité parentale, ou à défaut de votre/vos
          tuteur(s) légaux pour accepter le présent contrat. Vous vous engagez à
          justifier de cette autorisation, sans délai, sur première demande de
          Skeepers.
        </p>
        <p>
          En cas de contradiction entre le présent contrat et les conditions
          générales d’utilisation du site et de la plateforme Skeepers, les
          stipulations du présent contrat prévaudront.
        </p>
        <p>
          En cas d’annulation par un tribunal ou toute autre autorité compétente
          d’une des clauses du présent contrat, toutes les autres clauses du
          présent contrat resteront en vigueur à moins que, du fait de
          l’annulation de la clause, celles-ci deviennent sans objet ou
          impossible à exécuter.
        </p>
        <p>Le présent accord est soumis au droit français.</p>
        <p>
          Aucune tolérance de Skeepers quelle qu’en soit la nature, l’ampleur,
          la durée ou la fréquence ne pourra être considérée comme créatrice
          d’un quelconque droit à votre profit ni être interprétée comme une
          renonciation de sa part à l’une quelconque des dispositions du présent
          contrat.
        </p>
        <p>
          De convention expresse, les courriers électroniques et les systèmes
          d’enregistrement automatiques utilisés sur le site et la plateforme
          Skeepers feront foi entre les parties.
        </p>
      </div>
    </>
  )
}

export default CommunityAgreementFR
